module.exports = __webpack_public_path__ + "static/media/comet.08a12a7f.svg";